(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../dialog", "../button", "../radio", "../checkbox", "../radio-group", "../checkbox-group", "../_util", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../dialog"), require("../button"), require("../radio"), require("../checkbox"), require("../radio-group"), require("../checkbox-group"), require("../_util"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.dialog, global.button, global.radio, global.checkbox, global.radioGroup, global.checkboxGroup, global._util, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _dialog, _button, _radio, _checkbox, _radioGroup, _checkboxGroup, _util, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _dialog = _interopRequireDefault(_dialog);
  _button = _interopRequireDefault(_button);
  _radio = _interopRequireDefault(_radio);
  _checkbox = _interopRequireDefault(_checkbox);
  _radioGroup = _interopRequireDefault(_radioGroup);
  _checkboxGroup = _interopRequireDefault(_checkboxGroup);
  _osProps = _interopRequireDefault(_osProps);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nx-dialog', {
        class: ['nx-dialog-list', !_vm.title ? 'nx-dialog-list_no-title' : '', _vm.$slots.default ? '' : 'nx-dialog-list-no-padding'],
        attrs: {
          "value": _vm.value,
          "title": _vm.title,
          "subTitle": _vm.subTitle,
          "closeDelMode": true,
          "btns": _vm.btns,
          "maskClosable": _vm.maskClosable,
          "isWebviewFull": _vm.isWebviewFull,
          "ariaPopupLabel": _vm.ariaPopupLabel,
          "multiplePopup": _vm.multiplePopup,
          "slideDownDisappear": _vm.slideDownDisappear,
          "backClosePopup": _vm.backClosePopup,
          "backClosePopupCustomEvent": _vm.backClosePopupCustomEvent,
          "blur-material": _vm.blurMaterial
        },
        on: {
          "input": function input($event) {
            return _vm.$emit('input');
          },
          "show": function show($event) {
            return _vm.$emit('show');
          },
          "hide": function hide($event) {
            return _vm.$emit('hide');
          },
          "maskClick": function maskClick($event) {
            return _vm.$emit('maskClick');
          }
        }
      }, [_c('div', {
        staticClass: "nx-dialog-list__container",
        attrs: {
          "nx-popup-aria-auto-focus": "true"
        }
      }, [_vm.$slots.default ? _vm._t("default") : _vm.type === 'text' ? _c('ul', {
        on: {
          "click": _vm.$_click
        }
      }, _vm._l(_vm.list, function (item) {
        return _c('li', {
          key: item.value,
          staticClass: "dialog-item left",
          class: _vm.borderGroupBorder ? 'is-border' : '',
          attrs: {
            "tabindex": "-1",
            "aria-label": item.ariaLabelContent,
            "data-value": item.value
          }
        }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
      }), 0) : _vm.type === 'radio' ? _c('nx-radio-group', {
        ref: "radioGroup",
        attrs: {
          "border": false
        },
        on: {
          "change": _vm.$_change
        },
        model: {
          value: _vm.selectedValue,
          callback: function callback($$v) {
            _vm.selectedValue = $$v;
          },
          expression: "selectedValue"
        }
      }, _vm._l(_vm.list, function (item) {
        return _c('nx-radio', {
          key: item.value,
          class: [_vm.radioGroupBorder ? 'is-border' : '', item.disabled ? 'is-disabled' : ''],
          attrs: {
            "name": item.value,
            "labelPosition": "right",
            "radioColor": _vm.radioColor,
            "disabled": item.disabled
          }
        }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
      }), 1) : _vm.type === 'checkbox' ? _c('nx-checkbox-group', {
        attrs: {
          "max": _vm.max,
          "border": false
        },
        on: {
          "showMaxTip": _vm.$_handleMax,
          "change": _vm.$_change
        },
        model: {
          value: _vm.selectedValue,
          callback: function callback($$v) {
            _vm.selectedValue = $$v;
          },
          expression: "selectedValue"
        }
      }, _vm._l(_vm.list, function (item) {
        return _c('nx-checkbox', {
          key: item.value,
          class: [_vm.borderGroupBorder ? 'is-border' : '', item.disabled ? 'is-disabled' : ''],
          attrs: {
            "name": item.value,
            "disabled": item.disabled,
            "labelPosition": "right"
          }
        }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
      }), 1) : _vm._e(), !_vm.title ? _c('div', {
        ref: "nx-dialog-list-aria",
        staticClass: "nx-dialog-list-aria",
        attrs: {
          "aria-live": "polite"
        }
      }) : _vm._e()], 2)]);
    },
    name: 'nx-dialog-list',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      list: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      title: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text',
        validator: function validator(type) {
          return ['text', 'radio', 'checkbox'].indexOf(type) > -1;
        }
      },
      max: Number,
      maskClosable: {
        type: Boolean,
        default: false
      },
      defaultValue: {
        type: [String, Array],
        default: ''
      },
      okText: {
        type: String,
        default: ''
      },
      cancelText: {
        type: String,
        default: ''
      },
      radioGroupBorder: {
        type: Boolean,
        default: false
      },
      borderGroupBorder: {
        type: Boolean,
        default: true
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          return _util.isCombineWallet && location.href && location.href.indexOf('sink=1') > -1;
        }
      },
      ariaPopupLabel: {
        type: String,
        default: '弹出式窗口，'
      },
      slideDownDisappear: {
        default: undefined
      },
      backClosePopup: {
        type: Boolean,
        default: false
      },
      backClosePopupCustomEvent: {
        type: String,
        default: 'popstate'
      },
      multiplePopup: {
        type: Boolean,
        default: false
      },
      appendTo: {
        default: undefined
      },
      radioColor: {
        type: String,
        default: ''
      }
    },
    components: (_components = {}, (0, _defineProperty2.default)(_components, _dialog.default.name, _dialog.default), (0, _defineProperty2.default)(_components, _button.default.name, _button.default), (0, _defineProperty2.default)(_components, _radio.default.name, _radio.default), (0, _defineProperty2.default)(_components, _radioGroup.default.name, _radioGroup.default), (0, _defineProperty2.default)(_components, _checkbox.default.name, _checkbox.default), (0, _defineProperty2.default)(_components, _checkboxGroup.default.name, _checkboxGroup.default), _components),
    mixins: [_osProps.default],
    data: function data() {
      return {
        selectedValue: this.type === 'checkbox' && this.defaultValue === '' ? [] : this.defaultValue
      };
    },
    computed: {
      /* eslint-disable vue/return-in-computed-property */
      btns: function btns() {
        var btns = [{
          text: this.cancelText || '取消',
          type: 'link',
          handler: this.$_onCancel
        }];

        if (this.type === 'radio') {
          return [{
            text: this.cancelText || '取消',
            type: 'link',
            handler: this.$_onCancel
          }];
        } else if (this.type === 'checkbox') {
          return [{
            text: this.okText || '确定',
            type: 'primary',
            handler: this.$_onConfirm
          }, {
            text: this.cancelText || '取消',
            type: 'link',
            handler: this.$_onCancel
          }];
        } else if (this.cancelText) {
          return btns;
        }
      }
    },
    watch: {
      value: function value(_new) {
        var _this = this;

        if (_new) {
          if (this.type === 'radio') {
            var dom = this.$refs.radioGroup.$el;
            var selectIndex = -1;
            this.list.forEach(function (item, index) {
              if (_this.selectedValue === item.value) selectIndex = index;
            });
            setTimeout(function () {
              if (dom && dom.firstChild && selectIndex > -1) {
                var el = dom.childNodes[selectIndex];
                el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }, 100);
          }
        } else {
          // 设置无障碍属性
          this._setDomAttrs();
        }
      }
    },
    mounted: function mounted() {
      if (this.appendTo) {
        this.appendTo.appendChild(this.$el);
      }

      this.value && (this.isDialogShow = this.value);

      this._setDomAttrs();
    },
    beforeDestroy: function beforeDestroy() {
      if (this.appendTo && this.appendTo.contains(this.$el)) {
        this.appendTo.removeChild(this.$el);
      }
    },
    methods: {
      // public method
      $_reset: function $_reset() {
        this.selectedValue = this.type === 'checkbox' && this.defaultValue === '' ? [] : this.defaultValue;

        this._setDomAttrs();
      },
      $_change: function $_change(val) {
        var _this2 = this;

        if (this.type === 'radio') {
          setTimeout(function () {
            _this2.$_onCancel();
          }, 100);
        }

        this.$emit('change', val);
      },
      $_onCancel: function $_onCancel() {
        this.$emit('cancel');
      },
      $_onConfirm: function $_onConfirm() {
        this.$emit('confirm', this.selectedValue);
      },
      $_click: function $_click(e) {
        var target = e.target || e.srcElement;

        if (target.nodeName.toLocaleLowerCase() === 'li') {
          var val = target.dataset.value;
          this.$emit('click', val);
        }
      },
      $_handleMax: function $_handleMax() {
        this.$emit('showMaxTip');
      },
      _setDomAttrs: function _setDomAttrs() {
        var _this3 = this;

        var ariaDom = this.$refs['nx-dialog-list-aria']; // 初始没有选中

        if (!ariaDom || this.selectedValue === '' || Array.isArray(this.selectedValue) && !this.selectedValue.length) return; // 初始有选中

        var ariaLabel = '';

        if (this.type === 'checkbox') {
          this.list.forEach(function (item) {
            if (_this3.selectedValue.indexOf(item.value) > -1) {
              ariaLabel += "\u5DF2\u9009\u4E2D-".concat(item.text, "-\u590D\u9009\u6846-");
            }
          });
        } else if (this.type === 'radio') {
          this.list.forEach(function (item) {
            if (_this3.selectedValue === item.value) {
              ariaLabel += "\u5DF2\u9009\u4E2D-".concat(item.text, "-\u5355\u9009-");
            }
          });
        }

        ariaDom.setAttribute('aria-label', ariaLabel);
      }
    }
  };
  _exports.default = _default2;
});